import type { Building } from "building-types/building/buildingTypes";
import type { OpeningHandle } from "building-types/handles/docEntityHandleTypes";
import type { ResolvedOpeningFraming, WallFraming, WallFramingMeta } from "building-types/walls/wallFramingTypes";
import type { RWTable, Table } from "common/data/table";

export function indexResolvedOpeningFramingFromMeta(
  meta: WallFramingMeta | undefined,
  openingToResolvedOpeningFraming: RWTable<ResolvedOpeningFraming>,
): void {
  const openingId = meta?.openingHandle?.id;
  const resolvedOpeningFraming = meta?.resolvedOpeningFraming;
  if (openingId === undefined || resolvedOpeningFraming === undefined) {
    return;
  }
  openingToResolvedOpeningFraming[openingId] = resolvedOpeningFraming;
}

export function collectResolvedOpeningFramingFromWallFramingList(
  wallFramings: readonly WallFraming[],
  openingToResolvedOpeningFraming: RWTable<ResolvedOpeningFraming>,
): void {
  for (const wallFraming of wallFramings) {
    for (const framing of wallFraming.framings) {
      indexResolvedOpeningFramingFromMeta(framing.meta, openingToResolvedOpeningFraming);
    }
  }
}

export function collectResolvedOpeningFramingFromWallFramingSystems(
  wallFramingSystems: Table<readonly WallFraming[]>,
  openingToResolvedOpeningFraming: RWTable<ResolvedOpeningFraming>,
): void {
  for (const levelId in wallFramingSystems) {
    const list = wallFramingSystems[levelId];
    if (list !== undefined) {
      collectResolvedOpeningFramingFromWallFramingList(list, openingToResolvedOpeningFraming);
    }
  }
}

export function findResolvedOpeningFraming(
  building: Building,
  openingHandle: OpeningHandle,
): ResolvedOpeningFraming | undefined {
  return building.openingToResolvedOpeningFraming[openingHandle.id];
}
